
import Logo from "./navbar/Logo";
import DesktopNavLinks from "./navbar/DesktopNavLinks";
import ContactFormDialog from "./navbar/ContactFormDialog";
import MobileMenu from "./navbar/MobileMenu";

const Navbar = () => {
  return (
    <nav className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-sm border-b border-slate-100">
      <div className="container mx-auto px-4 md:px-6 flex h-16 items-center justify-between">
        <Logo />
        <DesktopNavLinks />
        <div className="flex items-center space-x-4">
          <ContactFormDialog />
          <MobileMenu />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
